import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

export const pedidosCompraRoutes: RouteRecordRaw[] = [
  {
    path: '/pedidos-compra',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Compras — Liberações' },
    children: [
      {
        path: '',
        name: 'PedidosCompra',
        component: () => import('@/views/PedidosCompra/PedidosCompra.vue'),
        meta: { requiresAuth: true, title: 'Liberações', breadcrumb: 'Compras / Liberações' },
      },
    ],
  },
];

export default pedidosCompraRoutes;
